/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { StorageModule } from "@vlinder-web/storage-module-react";
import config from "../config/sidebarItems.config.json";
import jwt_decode from "jwt-decode";

const SERVICE_NAME = "AppNavigatorService.WhoamiService";
const log: any = LoggerModule.getInstance();

export interface IWhoamiMethods extends IPluginMethodMap {
  whoami(args: any): Promise<any>;
}

export class WhoamiService implements IAgentPlugin {
  readonly methods: IWhoamiMethods;

  constructor() {
    this.methods = {
      whoami: this.whoami.bind(this),
    };
  }

  async whoami(args: any) {
    let _token = this.checkValidToken();
    if (_token?.valid && _token?.token && _token?.role) {
      return { whoami: _token.role };
    } else {
      //TODO: FIX ME
      return { whoami: "" };
    }
  }

  private checkValidToken() {
    const storageSrv = StorageModule.getInstance();
    let _sessionToken = storageSrv.get("userProfile", "session")?.accessToken;
    let _localToken = storageSrv.get("userProfile", "local")?.accessToken;
    let _token = _localToken ?? _sessionToken;

    if (_token) {
      let decodedToken: any = jwt_decode(_token);
      let currentDate = new Date();
      if (decodedToken?.exp * 1000 < currentDate.getTime()) {
        return {
          valid: false,
          role: null,
          token: _token,
        };
      } else {
        return {
          valid: true,
          role: decodedToken?.role,
          token: _token,
        };
      }
    } else {
      return {
        valid: true,
        role: null,
        token: null,
      };
    }
  }
}
